<template>
  <v-data-table :headers="headers" :items="formatItems" calculate-widths no-data-text="No Extras created">
    <template v-slot:item.type="{ item }">
      <v-chip small>
        {{ item.type }}
      </v-chip>
    </template>
    <template v-slot:item.rooms="{ item }">
      <div class="d-inline-flex flex-wrap" v-if="item.units.length >= 4" active-class="primary--text" column>
        <v-chip class="mb-2 mr-1" small v-for="unit in [...item.units].splice(0, 3)" :key="unit.id">
          {{ unit.name }}
        </v-chip>

        <v-chip small>
          <primary-tool-tip icon="mdi-dots-horizontal">
            <span v-for="unit in item.units" :key="unit.id"> {{ unit.name }} <br /> </span>
          </primary-tool-tip>
        </v-chip>
      </div>
      <div class="d-inline-flex flex-wrap" v-else-if="item.units.length > 0 && item.units.length < 4" active-class="primary--text" column>
        <v-chip class="mb-2 mr-1" small v-for="unit in [...item.units].splice(0, 3)" :key="unit.id">
          {{ unit.name }}
        </v-chip>
      </div>
      <div v-else>
        <v-chip class="mb-2 mr-1" small>No rooms assigned</v-chip>
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list class="options-list">
          <v-list-item>
            <v-list-item-title>
              <router-link :to="{ name: 'place-extras-edit', params: { extraId: item.id, isDuplicate: false } }" title="Edit extra"> <v-icon left small>mdi-pencil</v-icon>Edit </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <router-link :to="{ name: 'place-extras-duplicate', params: { extraId: item.id, isDuplicate: true } }" title="Duplicate extra"> <v-icon left small>mdi-content-copy</v-icon>Duplicate </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <confirmation title="Delete Extra Confirmation" :submitHandler="deleteSubmitHandler" :entity="item.extra">
              <template v-slot:activator="props">
                <v-list-item-title @click.stop="props.showDialog" class="red--text"> <v-icon left small class="red--text">mdi-delete</v-icon>{{ $t('global-terms.delete') }} </v-list-item-title>
              </template>
              <template v-slot:body>
                <p>Are you sure you want to delete this extra?</p>
              </template>
            </confirmation>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'pinia'
import { useExtraStore, useUnitStore } from '@/stores'
import Confirmation from '@/components/dialogs/Confirmation'
import { EXTRA_TYPES } from '@/constants.js'
import { sortObjects } from '@/helpers/stateUtils'
import PrimaryToolTip from '@/components/tooltips/PrimaryToolTip.vue'
import { clone } from 'ramda'

export default {
  data () {
    return {
      headers: [
        { text: 'Name', value: 'name', sortable: false, width: '25%' },
        { text: 'Type', value: 'type', sortable: false, width: '25%' },
        { text: 'Rooms', value: 'rooms', sortable: false, width: '40%' },
        { align: 'end', value: 'actions', sortable: false, width: '10%' },
      ],
    }
  },
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useExtraStore, {
      extraFindByIds: 'findByIds',
    }),
    ...mapState(useUnitStore, {
      unitFindByExtraId: 'findByExtraId',
    }),
    extras () {
      return this.extraFindByIds(this.place.extras)
    },
    formatItems () {
      return sortObjects(
        this.extras.map((extra) => {
          return {
            id: extra.id,
            name: extra.name,
            type: this.formatType(extra.type),
            units: this.unitFindByExtraId(extra.id),
            extra,
          }
        }),
        'name'
      )
    },
  },
  methods: {
    clone,
    sortObjects,
    ...mapActions(useExtraStore, ['httpDeleteExtra']),
    deleteSubmitHandler (extra) {
      const placeClone = this.clone(this.place)
      return this.httpDeleteExtra({ extra, place: placeClone })
    },
    formatType (type) {
      const typeKey = Object.keys(EXTRA_TYPES).find((key) => key === type)
      return EXTRA_TYPES[typeKey] || 'Unknown'
    },
  },
  components: {
    Confirmation,
    PrimaryToolTip,
  },
}
</script>
